import { buildMldCountsQuery, buildMldListQuery } from './query';
import { MldCountsParams, MldListParams } from './types';

/**
 * React Query keys of the MLD read routes. The list and counts keys carry the
 * query actually sent to DS (every filter, the page and the page size), so any
 * change refetches and two params that send the same request share a cache.
 */
export const mldQueryKeys = {
  all: ['mld'] as const,
  list: (params: MldListParams = {}) =>
    ['mld', 'list', buildMldListQuery(params)] as const,
  counts: (params: MldCountsParams = {}) =>
    ['mld', 'counts', buildMldCountsQuery(params)] as const,
  detail: (subscriptionId: string) =>
    ['mld', 'detail', subscriptionId] as const,
  member: (customerId: string) => ['mld', 'member', customerId] as const,
};
